'use client'

import { fetchApi, INewQuoteForm } from '@repo/sdk'
import { useMutation } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

interface Props {
  drops: INewQuoteForm['drops']
}

export const CostRange = ({ drops }: Props) => {
  const [minPrice, setMinPrice] = useState<number>(690)
  const [maxPrice, setMaxPrice] = useState<null | number>(null)

  const { mutate: calculateCostMutation } = useMutation({
    mutationFn: async (drops: INewQuoteForm['drops']) => {
      const distances = []

      for (let index = 0; index < drops.length - 1; index++) {
        const drop1coordinates = drops[index].place.lat + ',' + drops[index].place.lng
        const drop2coordinates = drops[index + 1].place.lat + ',' + drops[index + 1].place.lng

        distances.push(drop1coordinates + ';' + drop2coordinates)
      }

      if (distances.length === 0) return

      const res = await fetchApi<{ maxCost: null | number; minCost: number }>(
        '/public/loads/calculate/cost',
        {
          body: JSON.stringify({
            destinationCountry: drops.at(-1)?.place.country,
            routes: distances,
          }),
          method: 'POST',
        },
      )

      setMinPrice(res.minCost)
      setMaxPrice(res.maxCost)
    },
  })

  useEffect(() => {
    calculateCostMutation(drops)
  }, [drops])

  return (
    <div className="text-sm font-semibold text-card-foreground">
      <span>FROM</span>
      <span className="mx-3 text-2xl font-bold text-brand">€{minPrice}</span>
      {minPrice > 690 ? (
        <>
          <span>TO</span>
          <span className="ml-3 text-2xl font-bold text-brand">€{maxPrice}</span>
        </>
      ) : null}
    </div>
  )
}
